import {Injectable} from '@angular/core';
import {Discount} from '../models/discount.model';
import { Subject } from 'rxjs/Subject';

@Injectable({providedIn: 'root'})
export class DiscountService {

    discounts: Discount[];
    discounts_sub = new Subject<Discount[]>();

    setDiscount(discounts: Discount[]) {
        this.discounts = discounts;
        this.discounts_sub.next(discounts.slice());
    }

    getDiscount() {
        return this.discounts;
    }

    getDiscountAmountById(discount_id: number) {
        return this.discounts.filter(item => item.id === discount_id)[0]['amount'];
    }

}
